<template>
  <TheModal class="confirm-modal" :show="true">
    <div class="enter__body modal__body center">
      <slot name="header">
        <div v-if="title" class="confirm-modal__title">
          {{ title }}
        </div>

        <div v-if="description" class="confirm-description">
          {{ description }}
        </div>

        <div class="confirm-modal__footer">
          <filled-button @click="onResolve(true)">
            Да
          </filled-button>

          <bordered-button @click="onResolve(false)">
            Отмена
          </bordered-button>
        </div>
      </slot>
    </div>
  </TheModal>
</template>

<script setup>
import TheModal from '@/components/TheModal.vue'
import FilledButton from '@/components/element/buttons/Filled.vue'
import BorderedButton from '@/components/element/buttons/Bordered.vue'

defineProps(['title', 'onResolve', 'description'])
</script>

<style lang="scss" scoped>
.confirm-modal {
  .modal__body {
    width: clamp(200px, 500px, 100%);
  }

  &__title {
    font-size: 24px;
    line-height: 104%;
    margin-bottom: 24px;
  }

  &__footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
